import PrimaryMenuItem from '../model/PrimaryMenuItem.js';
import SecondaryMenuItem from '../model/SecondaryMenuItem';

// 第一層
const marketing = new PrimaryMenuItem('Market', 'storefront');
// 第二層
const QuestionnaireList = new SecondaryMenuItem('QuestionnaireList', () => import('@/modules/que/views/List.vue'));
const ActivityManagement = new SecondaryMenuItem('ActivityManagement', () => import('@/modules/act/views/Activity.vue'));
const SocialBroadcastsService = new SecondaryMenuItem('SocialBroadcastsService', () => import('@/modules/sbs/views/List.vue'));
const CommunicationAutoReply = new SecondaryMenuItem('CommunicationAutoReply', () => import('@/modules/arp/views/List.vue'));
const QRCodeManagement = new SecondaryMenuItem('QRCodeManagement', () => import('@/modules/mms/views/List.vue'));
const RichMenuManagement = new SecondaryMenuItem('RichMenuManagement', () => import('@/modules/rmu/views/RichMenu.vue'));
const RewardManagement = new SecondaryMenuItem('RewardManagement', () => import('@/modules/rmg/views/List.vue'));
const ConsiderableTagAlter = new SecondaryMenuItem('ConsiderableTagAlter', () => import('@/modules/cpn/views/List.vue'));
const AudienceListManagement = new SecondaryMenuItem('AudienceListManagement', () => import('@/modules/alm/views/View.vue'));
// const MarketManagement = new SecondaryMenuItem('MarketManagement', () => import('@/modules/que/views/List.vue'));
// 註冊第二層
marketing.RegisterChild(QuestionnaireList);
marketing.RegisterChild(ActivityManagement);
marketing.RegisterChild(SocialBroadcastsService);
marketing.RegisterChild(CommunicationAutoReply);
marketing.RegisterChild(QRCodeManagement);
marketing.RegisterChild(RichMenuManagement);
marketing.RegisterChild(RewardManagement);
marketing.RegisterChild(ConsiderableTagAlter);
marketing.RegisterChild(AudienceListManagement);
// marketing.RegisterChild(MarketManagement);
// 第三層

export default marketing;
